export default __webpack_public_path__ + "static/media/tickets.f4194794.png";